import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import Media from 'react-media';

import StickyBox from "react-sticky-box";

import { loadFilters, loadJewels, setCurrentPage } from '../../../redux/jewels/actions';

import JewelsToolbar from '../JewelsToolbar/JewelsToolbar'
import JewelsFilters from '../JewelsFilters/JewelsFilters'
import JewelsCards from '../JewelsCards/JewelsCards'
import JewelsPager from '../JewelsPager/JewelsPager'

class JewelsList extends Component {

    componentDidMount(){
      this.props.loadJewels();
    }

    componentDidUpdate(prevProps){
      if(this.props.currentpage != prevProps.currentpage || this.props.selectedfilters != prevProps.selectedfilters  || this.props.length != prevProps.length){
        this.props.loadJewels();
      }
    }
    handlePageChange = (page)=>{
      this.props.setCurrentPage(page.selected);
    }
    render() {
        return(
            <div>
              <Media query={{ maxWidth: 751 }}>
          {matches => (
            <Fragment>
              {matches ? <Fragment><JewelsFilters /><JewelsToolbar /></Fragment>
            : <StickyBox style={{zIndex:3000}}>
            <JewelsFilters />
            <JewelsToolbar />
            </StickyBox> }
            </Fragment>
          )}
        </Media>
            
            <JewelsCards />
            <JewelsPager />
            </div>
        );
    }
}

const mapStateToProps = (state)=>{
  return {
    filters: state.jewels.filters,
    selectedfilters: state.jewels.selectedfilters,
    currentpage:state.jewels.currentpage,
    totalpage:state.jewels.totalpage,
    length: state.jewels.length
  }
};


export default connect(mapStateToProps, {loadFilters,loadJewels})(JewelsList);
